import { render, staticRenderFns } from "./Boolean.vue?vue&type=template&id=c238f3ea&scoped=true&"
import script from "./Boolean.vue?vue&type=script&lang=js&"
export * from "./Boolean.vue?vue&type=script&lang=js&"
import style0 from "./Boolean.vue?vue&type=style&index=0&id=c238f3ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c238f3ea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c238f3ea')) {
      api.createRecord('c238f3ea', component.options)
    } else {
      api.reload('c238f3ea', component.options)
    }
    module.hot.accept("./Boolean.vue?vue&type=template&id=c238f3ea&scoped=true&", function () {
      api.rerender('c238f3ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/domains/profile/components/ProfileField/field-types/Boolean.vue"
export default component.exports